import React from "react";
import { NavLink } from "react-router-dom";
import "./GradientButton.css";

const GradientButton = ({ buttonText, to }) => {
  return (
    <div className="out-background">
      <div className="border-wrapper">
        <NavLink
          to={to}
          className="gradient-btn text-decoration-none d-block text-center"
        >
          {buttonText}
        </NavLink>
      </div>
    </div>
  );
};

export default GradientButton;
